<template>
    <div class="titan-image-field">
        <template v-if="loading">
            <font-awesome-icon icon="spinner" class="mt-1 mb-1" :spin="true"/>
            <span>Uploading...</span>
        </template>
        <template v-if="loading === false">
            <div class="titan-image-preview" v-if="isSetValueImage === true">
                <img :src="value" :alt="schema.label">
            </div>
            <div class="titan-image-preview" v-if="isSetValueImage === false && originalImageModel !== null">
                <img :src="originalImageModel" :alt="schema.label">
            </div>
            <label>
                <div class="btn btn-primary" :class="buttonStyleClass">
                    <font-awesome-icon :icon="buttonIcon"/>
                    {{buttonName}}
                </div>
                <input :id="schema.model" class="d-none" type="file" ref="image" @change="saveValue()">
            </label>
            <div v-if="error !== null" class="errors help-block"><span>{{t(error)}}</span></div>
        </template>
    </div>
</template>
<script>
    import {abstractField} from 'vue-form-generator'

    export default {
        mixins: [abstractField],
        watch: {},
        computed: {
            isSetValueImage() {
                return this.value !== undefined && this.value !== null && this.value.trim() !== '';
            },
            buttonStyleClass() {
                return this.schema.buttonStyleClass === undefined ? 'btn-primary' : this.schema.buttonStyleClass;
            },
            buttonName() {
                return this.schema.buttonName === undefined ? 'Upload' : this.schema.buttonName;
            },
            originalImageModel() {
                return this.schema.originalImageModel === undefined ? null : this.model[this.schema.originalImageModel];
            },
            buttonIcon() {
                return this.schema.buttonIcon === undefined ? 'cloud-upload-alt' : this.schema.buttonIcon;
            },
            supportedTypes() {
                const defaults = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'];
                return this.schema.supportedTypes === undefined ? defaults : this.schema.supportedTypes;
            },
            upload() {
                return this.schema.upload === undefined ? false : this.schema.upload;
            }
        },
        methods: {
            saveValue() {
                this.loading = true;
                this.error = null;

                const promise = this.upload === false ? this.getBase64() : this.upload(this.$refs.image.files[0]);

                promise.then(res => {
                    this.value = res;
                    this.loading = false;
                }).catch(error => {
                    this.error = error;
                    this.loading = false;
                });
            },
            getBase64() {
                const file = this.$refs.image.files[0];

                return new Promise((resolve, reject) => {
                    if (this.validateImage(file.type) === false) {
                        reject('Unsupported image format');
                    } else {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = () => resolve(reader.result);
                        reader.onerror = error => reject(error);
                    }
                });
            },
            validateImage(type) {
                return this.supportedTypes.includes(type);
            }
        },
        data() {
            return {
                loading: false,
                error: null,
            }
        }
    };
</script>
<style lang="scss">
    .titan-image-field {
        .titan-image-preview {
            margin-top: 5px;
            margin-bottom: 5px;

            img {
                max-width: 30%;
                max-height: 100px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/core/Form/Fields/Image.vue